import { CanaryAIIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import CanaryAIHeroImage from '../../assets/product-images/canary-ai-product-hero.png';

export const APP_CONFIG_CANARYAI: AppConfig = {
  name: 'CanaryAI',
  applicationKey: 'canaryai',
  type: 'product',
  appSlugForEngagement: AppSlugs.CanaryAI,
  rootPath: `/canaryai`,
  Icon: CanaryAIIcon,
  descriptionLong:
    'Make housing data conversational with CanaryAI. Convert complex data into easy-to-understand conversations.',
  descriptionShort:
    'Ask a question and get instant answers based on our industry-leading data and analytics.',
  marketingImage: CanaryAIHeroImage,
};
